import { useContext } from 'react';

import SiteSettingsContext from './siteSettings.context';

function useSiteSettings() {
  const context = useContext(SiteSettingsContext);

  if (!context) {
    throw new Error('useSiteSettings must be used within SiteSettingsContext');
  }

  return context;
}

export default useSiteSettings;